import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../../core/client';
import type { MasterDataEntityPath, MasterDataResponse } from './master-data.types';

const BASE = '/users/v1/admin/master-data';
const KEY = ['master-data'] as const;

/** One round trip for the whole console — reference data is small by nature. */
export function useMasterData() {
  return useQuery({
    queryKey: KEY,
    queryFn: () => api.get<MasterDataResponse>(BASE),
  });
}

/** POST upsert (empty id = create) for any master-data entity. */
export function useUpsertMasterData<T extends object>(entity: MasterDataEntityPath) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (record: T) => api.post<T>(`${BASE}/${entity}`, record),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useDeleteMasterData(entity: MasterDataEntityPath) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete<boolean>(`${BASE}/${entity}/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
